export default __webpack_public_path__ + "static/media/share.518a880c.mp4";